const cancelDialog = {
	alert:
		"Achtung! Diese Aktion kann bis <strong>{{date}}</strong> rückgängig gemacht werden. Am <strong>{{date}}</strong> wird der PBS-Datenspeicher dauerhaft gelöscht.",
	description:
		"Wenn Sie diesen PBS-Abonnement kündigen, endet er am <strong>({{date}})</strong> und die Daten werden dauerhaft gelöscht. Zur Bestätigung bitten wir Sie, den Namen des PBS (<strong>{{name}}</strong>) unten zu wiederholen.",
	input: {
		label: "PBS Name",
		placeholder: "PBS-Namen wiederholen",
	},
	messages: {
		success:
			"Ihr Antrag auf Stornierung von PBS <strong>{{name}}</strong> wurde erfolgreich erhalten. Ihr PBS-Abonnement wird bis zum <strong>{{date}}</strong> gekündigt und alle Daten gelöscht.",
	},
	submit_button: "PBS-Abonnement kündigen",
	title: "PBS-Abonnement kündigen",
};

const cancellationPending = {
	button: "Kündigung rückgängig machen",
	description:
		"Achtung! Dieser PBS-Abonnement wurde gekündigt und wird ab dem <strong>{{date}}</strong> nicht mehr verfügbar sein. Sie können diese Aktion jetzt noch rückgängig machen.",
	dialog: {
		description:
			"Sind Sie sicher, dass Sie die PBS-Abonnement kündigung für <strong>{{name}}</strong> rückgängig machen möchten? Der Dienst wird erneut abgerechnet.",
		messages: {
			success:
				"Die PBS-Abonnement kündigung für PBS <strong>{{name}}</strong> wurde erfolgreich rückgängig gemacht. Das Abonnement bleibt aktiv.",
		},
		title: "PBS-Abonnement kündigung rückgängig machen",
	},
};

const edit = {
	status_messages: {
		success: "Ihr PBS wurde erfolgreich aktualisiert!",
	},
	title: "PBS verwalten - {{name}}",
};

const editSync = {
	no_sync_job:
		"Kein Synchronisierungsauftrag für PBS <strong>{{name}}</strong> gefunden. Bitte stellen Sie sicher, dass für diesen PBS ein aktiver Synchronisierungsauftrag konfiguriert ist.",
	title: "PBS sync verwalten - {{name}}",
};

const overview = {
	bttn_create: "Tuxis PBS erstellen",
	card: {
		body: {
			free_version: "Kostenlose Version",
			hostname: "PBS-Hostname",
			in_use: "In Verwendung",
			location: "Serverstandort",
			name: "Datastore-Name",
			new: "Kürzlich erstellt",
			username: "PBS-Benutzer",
		},
		footer: {
			bttn: "Details anzeigen",
		},
		progress: {
			auto_expand: {
				chart_icon:
					"Wenn Ihr Datastore diese Grenze erreicht, dann wird es automatisch vergrößert.",
				notification:
					"Sie erhalten eine E-Mail-Benachrichtigung, wenn der Datastore das Limit von <strong>{{value}}</strong> überschreitet.",
			},
			limited_size: {
				data_usage: "{{current}} von {{total}}",
				notification:
					"Sie erhalten eine E-Mail-Benachrichtigung, wenn weniger als <strong>{{value}}</strong> freier Speicherplatz vorhanden ist.",
			},
			no_usage_alert:
				"Derzeit kann die Datastorenutzung nicht abgerufen werden. Bitte versuchen Sie es später erneut.",
			title: "Datastorenutzung",
		},
	},
	empty: "Sie haben noch keinen Tuxis PBS Konto",
	title: "Tuxis PBS Übersicht",
};

const page = {
	alert_tile: {
		alert_email_address: "Benachrichtigungsadresse",
		alert_pruning: {
			disabled: "Nein",
			enabled: "Ja",
			label: "Bei Fehlern beim Bereinigen benachrichtigen",
		},
		alert_threshold: {
			disabled: "Niemals",
			enabled_auto_expand: "mehr als <strong>{{value}}</strong> in Benutzung ist",
			enabled_limited_size: "weniger als <strong>{{value}}</strong> Speicherplatz frei ist.",
			label: "Benachrichtigen wenn",
		},
		title: "Benachrichtigungen",
	},
	current_usage: {
		in_use: "Derzeit in Benutzung",
		quota_limited_size: "Maximale Datenspeicherkapazität",
		title: "Aktuelle Nutzung",
	},

	data_usage: {
		title: "Speichernutzung",
	},
	delete_button: "PBS-abbonnement kündigen",
	edit_button: "PBS bearbeiten",

	info_tile: {
		description: "Beschreibung",
		host: "PBS Hostname",
		location: "Serverstandort",
		name: "Datenspeichername",

		product_config: {
			auto_expand: "Grow as you go",
			free_version: "Datenspeicher Festes Limit - Kostenlos",
			limited_size: "Datenspeicher Festes Limit",
			title: "Speicherkonfiguration",
		},
		product_variant: {
			free: "Tuxis PBS Kostenlos - 150 GB",
			paid: "Tuxis PBS pro 1 TB",
			sync_job: "Synchronisierte Datenspeichervariante",
			title: "Varianten-Datenspeicher",
		},
		relation_title: "Verknüpfte Beziehung",
		title: "PBS-Informationen",
		username: "PBS-Benutzer",
	},
	password_tile: {
		credentials_saved_button: "Ich habe die Anmeldeinformationen gespeichert",
		description:
			"Die Anmeldedaten werden <strong>30 Tage lang</strong> im Passwort-Tresor gespeichert. Speichern Sie diese Anmeldedaten in Ihrem eigenen Passwort-Manager. Wählen Sie beim Anmelden im PBS-Webportal den Bereich <strong>@pbs - Proxmox Backup authentication server</strong> aus. Um Ihre Proxmox VE-Server zu verbinden, verwenden Sie bitte den API-Schlüssel, den wir für Sie erstellt haben.",
		description_completed:
			"Sie haben die Anmeldedaten aus dem Passwort-Tresor Ihres Passwort-Managers gespeichert. Wählen Sie beim Anmelden im PBS-Webportal den Bereich <strong>@pbs - Proxmox Backup authentication server</strong> aus. Um Ihre Proxmox VE-Server zu verbinden, verwenden Sie bitte den API-Schlüssel, den wir für Sie erstellt haben.",
		password_vault_button: "Zum Passworttresor",
		title: "PBS-Anmeldeinformationen",
	},
	sync_job: {
		link_pbs_external: "Sync-Job anzeigen",
		pbs_source_id: "Ausgewählter Tuxis PBS",
		remote_auth_id: "Auth-ID",
		remote_datastore: "Remote-Datenspeicher",
		remote_host: "Remote-Host",
		schedule: "Synchronisationsintervall",
		source_pbs_variant: "Quell-PBS-Variante",
		ssl_fingerprint: "SSL-Fingerabdruck",
		sync_status: "Sync status",
		title: "Sync-Job",
	},
	sync_job_dialog_delete: {
		description:
			"Sind Sie sicher, dass Sie den Sync-Job für PBS <strong>{{datastore_name}}</strong> löschen möchten?",
		success: "Der sync-job wurde erfolgreich für PBS <strong>{{datastore_name}}</strong> entfernt!",
		title: "Sync-Job löschen?",
		warning:
			"Achtung! Wenn Sie einen Sync-Job löschen, kann dieser nicht erneut für diesen PBS erstellt werden. Der PBS-Dienst bleibt bestehen und muss separat gekündigt werden.",
	},
};

const table = {
	body: {
		is_free_version: "- Kostenlos",
	},
	header: {
		cancellation_pending: "Gekündigt",
		created_at: "Erstellt am",
		datastore_config: "Konfiguration",
		datastore_name: "Datastore Name",
		host: "Hostname",
		id: "PBS id",
		location: "Server Standort",
	},
};

const manage = {
	cancel_dialog: cancelDialog,
	cancellation_pending: cancellationPending,
	edit: edit,
	edit_sync: editSync,
	overview: overview,
	page: page,
	table: table,
};

export default manage;
